export class ConfirmationDialogDataModel {
    CustomPhrase: string;
    ConfirmButton: string;
    CancelButton: string;
    ItemList?: Array<any>;
    ForceShowConfirm?: boolean;
    ForceShowCancel?: boolean;
    ForceRemoveX?: boolean;
    CustomButton?: any;

    constructor(cfd: ConfirmationDialogDataModel) {
        this.CustomPhrase = cfd.CustomPhrase;
        this.ConfirmButton = cfd.ConfirmButton;
        this.CancelButton = cfd.CancelButton;
        this.ItemList = cfd.ItemList;
        this.ForceShowConfirm = cfd.ForceShowConfirm;
        this.ForceShowCancel = cfd.ForceShowCancel;
        this.ForceRemoveX = cfd.ForceRemoveX;
        this.CustomButton = cfd.CustomButton;
    }
}
